import React from 'react';
import type { MockOrder, MockViewerRole } from '../types';
import { PriceCard, DriverCard, LoadCard, PartyStrip } from '../cards';

export interface OverviewTabProps {
  order: MockOrder;
  viewer: MockViewerRole;
}

/**
 * The default "summary" tab: original card grid (Price, Driver, Load,
 * Parties). Kept as a discrete tab so users land on it by default
 * and can flip away to Timeline / Photos / Activity when they want
 * a different lens.
 */
export const OverviewTab: React.FC<OverviewTabProps> = ({ order, viewer }) => {
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-12">
      <div className="md:col-span-7">
        <PriceCard order={order} viewer={viewer} />
      </div>
      <div className="md:col-span-5 flex flex-col gap-3">
        <DriverCard order={order} viewer={viewer} />
        <LoadCard order={order} viewer={viewer} />
      </div>
      <div className="md:col-span-12">
        <PartyStrip order={order} viewer={viewer} />
      </div>
    </div>
  );
};
